import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {catchError, Observable, of, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import {NGXLogger} from 'ngx-logger';
import { TipoSegnalazione } from '../models/tipoSegnalazione.model';


@Injectable({
  providedIn: 'root',
})
export class TipiSegnalazioneService{
  apiUrl: string = environment.apiUrl +"tipo-segnalazione";

  constructor(
    private http: HttpClient,
    private logger: NGXLogger

    ) {}


  get(): Observable<any> {
    const headers = {
     // 'Authorization': `Bearer ${token}`,
    };

    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(this.apiUrl, httpOptions);
  }

  getByAreaCompetenza(idAreaCompetenza:number): Observable<any> {
    const headers = {
     // 'Authorization': `Bearer ${token}`,
    };

    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(this.apiUrl+"?areaCompetenza="+idAreaCompetenza, httpOptions);
  }

  crea(tipoSegnalazione:TipoSegnalazione): Observable<any> {
    const headers = {
    //  'Authorization': `Bearer ${token}`,
    };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(this.apiUrl, tipoSegnalazione, httpOptions);

  }


  modifica(tipoSegnalazione:TipoSegnalazione): Observable<any> {

    const headers = {
    //  'Authorization': `Bearer ${token}`,
    };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.put(this.apiUrl+"/"+tipoSegnalazione.id, tipoSegnalazione, httpOptions);
  }

  elimina(idTtipoSegnalazione:string): Observable<any> {
    const headers = {
    //  'Authorization': `Bearer ${token}`,
    };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.delete(this.apiUrl+"/"+idTtipoSegnalazione, httpOptions);

  }




}
